module.exports = __webpack_public_path__ + "static/img/t4.d8b35559.png";